module.exports = __webpack_public_path__ + "static/media/bags1.83edbc2b.jpg";